module.exports = __webpack_public_path__ + "img/Logo.d9bdbfd2.png";